import { parse } from 'query-string'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/mapTo'
import * as App from '../../app'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Utils from './utils'

const updateUrl: ReduxObservable.Epic<any, any> = (
  action$,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies) =>
  action$.ofType(Constants.UPCOMING_SCHEDULES_UPDATE_SELECTED_DATE)
  .filter(() => history.location.pathname.startsWith(Menu.ADMIN_UPCOMING_SCHEDULES_URL))
  .mergeMap((action) => [
    App.updateUrlParams({dateSelect: null, selectedDate: action.date}),
    Actions.fetchUpcomingSchedules(
      store.getState().app.selectedCommunity,
      Utils.convertStartDateToDateString(null, action.date),
      Utils.convertEndDateToDateString(null, action.date))])

const initialLoad = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies) =>
  action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.ADMIN_UPCOMING_SCHEDULES_URL))
  .map(() => parse(history.location.search))
  .map((searchParams) =>
    Actions.fetchUpcomingSchedules(
      store.getState().app.selectedCommunity,
      Utils.convertStartDateToDateString(searchParams.dateSelect, searchParams.selectedDate),
      Utils.convertEndDateToDateString(searchParams.dateSelect, searchParams.selectedDate)))

const dropDownUpdate: ReduxObservable.Epic<any, any> = (
  action$,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies) =>
  action$.ofType(IsActive.filterStatusConstant(Constants.CHANGE_DATE_SELECT))
  .filter(() => history.location.pathname.startsWith(Menu.ADMIN_UPCOMING_SCHEDULES_URL))
  .filter((action) => action.filter.value !== Constants.DATE_SELECT_CUSTOM_MODE)
  .mergeMap((action) => [
    App.updateUrlParams({dateSelect: action.filter.value, selectedDate: null}),
    Actions.fetchUpcomingSchedules(
      store.getState().app.selectedCommunity,
      Utils.convertStartDateToDateString(action.filter.value, null),
      Utils.convertEndDateToDateString(action.filter.value, null)),
  ])

export const epic = ReduxObservable.combineEpics(
  dropDownUpdate,
  initialLoad,
  updateUrl,
)



// WEBPACK FOOTER //
// ./src/pages/upcoming-schedules/epic.ts